import { Inject, Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigService } from './config.service';
import { DeviceInfo} from '../model/device-info';
import {BasicResponse } from '../model/basic-response';
import { SortFilterInterface } from '../model/sort-filter';


export interface UserDeviceAPI {
  items: DeviceInfo[];
  total_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserDeviceService {
  private URL;
  headers: HttpHeaders;

  constructor(@Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }

  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getUserDevices(uacID: number): Observable<UserDeviceAPI> {

    const headers = this.headers;

    return this.httpClient.get<UserDeviceAPI>(
        `${this.URL}/accesscontrol/user/devices/${uacID}`, {headers}).pipe(
        catchError(UserDeviceService.handleHTTPError)
    );

  }

  updateUserDevice(deviceObj: DeviceInfo): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.put<BasicResponse>(`${this.URL}/accesscontrol/user/device/`,
        deviceObj, {headers})
        .pipe(
            catchError(UserDeviceService.handleHTTPError)
        );
  }


  deleteDevice(device: DeviceInfo): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.delete<BasicResponse>(`${this.URL}/accesscontrol/user/device/${device.id}`, {headers})
        .pipe(
            catchError(UserDeviceService.handleHTTPError)
        );

  }
}
